import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HeroSection } from './components/HeroSection';
import { TrustSection } from './components/TrustSection';
import { CertificationsSection } from './components/CertificationsSection';
import { DifferentiatorsSection } from './components/DifferentiatorsSection';
import { TeamIntroSection } from './components/TeamIntroSection';
import { CapabilitiesSection } from './components/CapabilitiesSection';
import { GovernmentProgramsSection } from './components/GovernmentProgramsSection';
import { ProjectsSection } from './components/ProjectsSection';
import { NSWCoverageSection } from './components/NSWCoverageSection';
import { CTASection } from './components/CTASection';
import { ContactSection } from './components/ContactSection';
import './App.css';

const Home = () => {
  return (
    <>
      <HeroSection />
      <CapabilitiesSection />
      <TrustSection />
      <DifferentiatorsSection />
      <GovernmentProgramsSection />
      <ProjectsSection />
      <TeamIntroSection />
      <CertificationsSection />
      <NSWCoverageSection />
      <CTASection />
      <ContactSection />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
